import { makeStyles } from '@griffel/react';

export const useClassNames = makeStyles({
  yammerLogo: {
    fill: 'var(--colorBrandForeground1)',
  },
});
